import { NgModule }             		  from '@angular/core';
import { RouterModule, Routes } 		  from '@angular/router';

import { AuthGuard } from './_guards';

import { LoginComponent }      			  from './login/login.component';
import { UploadpicComponent }      		from './verify/upload-pic.component';
import { DashboardComponent }         from './dashboard/dashboard.component';
import { HomeComponent }              from './home/home.component';
import { BatchdetailComponent }       from './batch/batch-detail.component';
import { CompletebatchComponent }     from './batch/complete-batch.component';
import { ProctorComponent }           from './proctor/proctor.component';
import { TestComponent }              from './test/test-page.component';
import { VivaComponent }              from './test/viva-page.component';
import { StudentsComponent }          from './student/students.component';
import { StudentlistComponent }       from './student/student-list.component';
import { LaunchpageComponent }        from './verify/launch-page.component';
import { ExamlistComponent }          from './examlist/exams-list.component';
import { PracticalComponent }         from './student/practical.component';
import { VideoConfComponent } from './student/video-conf.component';
import { MarksComponent } from './student/marks.component';
import { IntermidiateComponent } from './intermidiate/intermidiate.component';
import { DesStudentListComponent } from './des-student-list/des-student-list.component';
import { DesMarksComponent } from './des-marks/des-marks.component';
import { VivaMarksComponent } from './viva-marks/viva-marks.component';
import { ChatComponent } from './chat/chat.component';
import { VivaPcComponent } from './viva-pc/viva-pc.component';
import { FeedbackstartComponent } from './verify/feedback-start.component';
import { FeedbackComponent } from './verify/feedback.component';


const routes: Routes = [
	  { path: '', redirectTo: '/login', pathMatch: 'full' },
	  { path: 'login', component: LoginComponent },
    { path: 'dashboard/:step', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'home/:step/:step2/:step3/:step4', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'batch-detail', component: BatchdetailComponent, canActivate: [AuthGuard] },
    { path: 'upload-pic', component: UploadpicComponent, canActivate: [AuthGuard]},
    { path: 'students', component: StudentsComponent, canActivate: [AuthGuard] },
    { path: 'student-list/:step', component: StudentlistComponent, canActivate: [AuthGuard] },
    { path: 'practical-list', component: PracticalComponent, canActivate: [AuthGuard] },
    { path: 'complete-batch', component: CompletebatchComponent, canActivate: [AuthGuard] },
    { path: 'proctor-view', component: ProctorComponent, canActivate: [AuthGuard] },
    { path: 'theory-test', component: TestComponent, canActivate: [AuthGuard] },
    { path: 'viva-test/:step/:step2', component: VivaComponent, canActivate: [AuthGuard] },
    { path: 'video/:id/:stdid', component: IntermidiateComponent, canActivate: [AuthGuard] },
    { path: 'test-start/:step/:step2', component: LaunchpageComponent, canActivate: [AuthGuard] },
    { path: 'exam-list', component: ExamlistComponent, canActivate: [AuthGuard] },
    { path: 'video-con', component: VideoConfComponent, canActivate: [AuthGuard] },
    { path: 'marks/:id/:stdid', component: MarksComponent, canActivate: [AuthGuard] },
    { path: 'descriptive', component: DesStudentListComponent, canActivate: [AuthGuard] },
    { path: 'des-marks/:stdid', component: DesMarksComponent, canActivate: [AuthGuard] },
    { path: 'viva-marks/:stdid', component: VivaMarksComponent, canActivate: [AuthGuard] },
    { path: 'viva-pc/:step', component: VivaPcComponent, canActivate: [AuthGuard] },
    { path: 'chat', component: ChatComponent, canActivate: [AuthGuard] },
    { path: 'start-feedback', component: FeedbackstartComponent, canActivate: [AuthGuard] },
    { path: 'feedback/:step', component: FeedbackComponent, canActivate: [AuthGuard] },   
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}